import {
  IParamsAddEmployee,
  IParamsGetAllTeamSalesDetail,
  IParamsUpdateManyEmployee,
} from 'interfaces/TeamSaleDetail/TeamSaleDetail';
import axiosGraphQL from './GraphQL/axiosGraphQL';
import {
  CREATE_MANY_EMPLOYEE_TS,
  DELETE_MANY_TEAM_SALE_DETAIL,
  GET_ALL_TEAM_SALES_DETAIL_BY_ID,
  Q_ADD_EMPLOYEE_TS,
  UPDATE_MANY_TEAM_SALE_DETAIL,
} from './GraphQL/Queries/teamSaleQuery';
import { TEAMSALE_DETAIL_VARIABLE } from './GraphQL/Variables/teamSaleDetail';

export const SaleTeamDetailApi = {
  getAllById: async (params: IParamsGetAllTeamSalesDetail) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_TEAM_SALES_DETAIL_BY_ID,
      variables: TEAMSALE_DETAIL_VARIABLE.getAllTeamSaleDetailsById(params),
    });
  },
  createTeamSaleDetail: async (params: IParamsAddEmployee) => {
    return await axiosGraphQL.post('/graphql', {
      query: Q_ADD_EMPLOYEE_TS,
      variables: TEAMSALE_DETAIL_VARIABLE.createEmployeeTS(params),
    });
  },
  createManyTeamSaleDetail: async (params: IParamsAddEmployee[]) => {
    return await axiosGraphQL.post('/graphql', {
      query: CREATE_MANY_EMPLOYEE_TS,
      variables: TEAMSALE_DETAIL_VARIABLE.createManyEmployeeTS(params),
    });
  },
  updateManyTeamSaleDetail: async (params: IParamsUpdateManyEmployee[]) => {
    return await axiosGraphQL.post('/graphql', {
      query: UPDATE_MANY_TEAM_SALE_DETAIL,
      variables: TEAMSALE_DETAIL_VARIABLE.updateManyEmployeeTS(params),
    });
  },
  deleteManyTeamSaleDetail: async (ids: string[]) => {
    return await axiosGraphQL.post('graphql', {
      query: DELETE_MANY_TEAM_SALE_DETAIL,
      variables: TEAMSALE_DETAIL_VARIABLE.deleteManyEmployeeTS(ids),
    });
  },
};
